import { render, staticRenderFns } from "./RemoveAliasDialog.vue?vue&type=template&id=29a8e462"
import script from "./RemoveAliasDialog.vue?vue&type=script&lang=js"
export * from "./RemoveAliasDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports